import { eventBus } from './core/eventBus.js'
import { RequestManager } from './core/requestManager.js'
import { registerAllSerializers } from './serializers/registerSerializers.js'

function setupRequestManager() {
  registerAllSerializers()
  new RequestManager()
  return { sendRequest }
}

async function sendRequest(entity, method, data) {
  const methods = {
    get: 'GET_DATA',
    post: 'POST_DATA',
    update: 'PUT_DATA',
    patch: 'PATCH_DATA',
    delete: 'DELETE_DATA',
  }
  return new Promise(resolve => {
    const reqId = `${Date.now()}-${Math.floor(Math.random() * 1e6)}`
    eventBus.on(`RESPONSE:${reqId}`, res => {
      if (res.statusCode === 200) resolve(res.data)
      else resolve(res)
    })
    eventBus.emit(methods[method], {
      entityType: entity,
      payload: data,
      requestId: reqId,
      id: data,
    })
  })
}

export default setupRequestManager
